import { Link } from "react-router-dom";

import { IconMenuItem } from "@/Components/v2/atoms/MenuItem";
import BetaPill from "@/Components/v2/atoms/Pill/BetaPill";
import { LinkType } from "@/Components/v2/constants/enum";

export interface SettingMenuItemProps {
  label: string;
  route: string;
  onClick?: (() => void) | undefined;
  hasAccess: boolean;
  isBeta?: boolean;
  icon?: React.ReactNode;
  selected?: boolean;
  type?: LinkType;
}

export const SettingMenuItem: React.FC<SettingMenuItemProps> = ({
  label,
  route,
  onClick,
  hasAccess,
  isBeta,
  icon,
  selected,
  type,
}) => {
  switch (type) {
    case LinkType.External:
      return (
        <a
          href={route}
          style={{ textDecoration: "none", color: "inherit" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <IconMenuItem
            sx={{ padding: "0.6rem 1rem", height: "46px" }}
            icon={icon}
            onClick={onClick}
            disabled={!hasAccess}
            selected={!!selected}
          >
            {label} {isBeta && <BetaPill />}
          </IconMenuItem>
        </a>
      );
    case LinkType.Internal:
      return (
        <Link to={route} style={{ textDecoration: "none", color: "inherit" }}>
          <IconMenuItem
            sx={{ padding: "0.6rem 1rem", height: "46px" }}
            icon={icon}
            onClick={onClick}
            disabled={!hasAccess}
            selected={!!selected}
          >
            {label} {isBeta && <BetaPill />}
          </IconMenuItem>
        </Link>
      );
    default:
      return null;
  }
};
export default SettingMenuItem;
